export const selectionTypes = {
  list: "list",
  step: "step",
  range: "range",
  single: "single",
  input: "input",
};